<template>
  <el-container class="productTask">
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :limits="limits"
          :columns-property="columnsProperty"
          :filter="filter"
          module="basic"
          :table-select="false"
          url="taskDispatchBillDisplays"
          :table-footer-msg="tableFooterMsg"
          :default-expand-all="true"
          @update="getTableFooterMsg">
        <template slot="adSearch">
          <div class="vm-search">
            <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
              <el-form-item label="工单编号">
                <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable/>
              </el-form-item>
              <el-form-item label="派工单号">
                <el-input v-model.trim="filter.billNo" placeholder="请输入派工单号" clearable/>
              </el-form-item>
              <el-form-item label="物料编号">
                <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
              </el-form-item>
<!--              <el-form-item label="物料类型">-->
<!--                <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>-->
<!--                  <el-option-->
<!--                      v-for="item in materialTypeList"-->
<!--                      :key="item.pkid"-->
<!--                      :label="item.materialTypeName"-->
<!--                      :value="item.pkid"/>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item label="物料类型">
                <el-select
                    v-model="materialTypeList"
                    :popper-append-to-body="false"
                    class="biddingStageSty"
                    multiple
                    clearable
                    placeholder="请选择"
                    @change="handleSelectMaterialType">
                  <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name" :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="物料名称">
                <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
              </el-form-item>
              <el-form-item label="规格型号">
                <el-input v-model.trim="filter.materialSpecification" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="工作中心">
                <el-input v-model.trim="filter.workCenterName" placeholder="请选择工作中心" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.workCenterSelect.open()"/>
                </el-input>
              </el-form-item>
              <el-form-item label="工单状态">
                <!--                <el-select v-model="filter.status" placeholder="请选择" clearable>-->
                <!--                  <el-option label="已排产" :value="20"/>-->
                <!--                  <el-option label="已开工" :value="30"/>-->
                <!--                  <el-option label="已完工" :value="80"/>-->
                <!--                  &lt;!&ndash;                <el-option label="已暂停" :value="40"/>&ndash;&gt;-->
                <!--                  <el-option label="已检验" :value="90"/>-->
                <!--                  <el-option label="已入库" :value="100"/>-->
                <!--                  <el-option label="已关闭" :value="999"/>-->
                <!--                </el-select>-->
                <el-select
                    v-model="biddingStage"
                    :popper-append-to-body="false"
                    class="biddingStageSty"
                    multiple
                    clearable
                    placeholder="请选择"
                    @change="handleSelect">
                  <!--                  <el-checkbox-group v-model="biddingStage">-->
                  <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value">
                    <!--                      <el-checkbox style="pointer-events: none" :label="item.name"/>-->
                  </el-option>
                  <!--                  </el-checkbox-group>-->
                </el-select>
              </el-form-item>
              <el-form-item label="发料状态">
                <el-select v-model="filter.feedingStatus" placeholder="请选择" clearable>
                  <el-option label="全部" :value="0"/>
                  <el-option label="待发料" :value="10"/>
                  <el-option label="部分发料" :value="20"/>
                  <el-option label="已发料" :value="80"/>
                </el-select>
              </el-form-item>
              <el-form-item label="计划开工日期">
                <el-date-picker
                    v-model="planStartDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('planStartDateRange', 'planStartFrom', 'planStartTo')"/>
              </el-form-item>
              <el-form-item label="计划完工日期">
                <el-date-picker
                    v-model="planFinishDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('planFinishDateRange', 'planFinishFrom', 'planFinishTo')"/>
              </el-form-item>
              <el-form-item label="开工日期">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('dateRange','startFrom','startTo')"/>
              </el-form-item>
              <el-form-item label="完工日期">
                <el-date-picker
                    v-model="finishDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('finishDateRange','finishFrom','finishTo')"/>
              </el-form-item>
              <el-form-item label="检验日期">
                <el-date-picker
                    v-model="inspectionDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('inspectionDateRange','inspectionStartTime','inspectionEndTime')"/>
              </el-form-item>
              <el-form-item label="入库日期">
                <el-date-picker
                    v-model="instockDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('instockDateRange','instockStartTime','instockEndTime')"/>
              </el-form-item>
              <el-form-item label="交货日期">
                <el-date-picker
                    v-model="deliveryDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('deliveryDateRange','soDeliveryStartDate','soDeliveryEndDate')"/>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template slot="actionBtn" slot-scope="scope">
          <el-button
              v-if="limits.startAuth"
              type="primary"
              :disabled="[30, 80,90,100].includes(scope.row.status) || scope.row.feedingStatus===10"
              @click="startWorking(scope.row)">
            开工
          </el-button>
          <el-button
              v-if="limits.finishAuth"
              type="danger"
              :disabled="scope.row.status !== 30 || scope.row.feedingStatus===10"
              @click="completeWorking(scope.row)">
            完工
          </el-button>
          <el-button v-if="limits.repairAuth" @click="repairProd(scope.row)">返修</el-button>

          <el-button
              v-if="limits.closeAuth"
              type="danger"
              :disabled="[10,20,100].includes(scope.row.status)"
              @click="closeWorking(scope.row)">
            关闭
          </el-button>
        </template>
      </view-table>
    </el-main>
    <!-- 工作中心选择 -->
    <work-center-select ref="workCenterSelect" @select="workCenterSelect"/>
    <production-order-preview ref="detailPage"/>
    <material-stock-preview ref="stockPreview"/>
  </el-container>
</template>
<script>
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import ProductionOrderPreview from "../ProductionOrder/ProductionOrderPreview.vue";
  import ViewTable from "@/components/ViewTable";
  import MaterialStockPreview from "@/views/ProductionManagement/ProductionProject/MaterialStockPreview";

  export default {
    name: "ProductionProcessList",
    components: {
      ViewTable,
      WorkCenterSelect,
      ProductionOrderPreview,
      MaterialStockPreview,
    },
    data() {
      return {
        limits: {
          startAuth: this.$auth(362),
          finishAuth: this.$auth(396),
          repairAuth: this.$auth(428),
          nameplatePrintAuth: this.$auth(389),
          labelPrintAuth: this.$auth(405),
          closeAuth: this.$auth(463),
        },
        loadingPrintCode: false,
        productionOrderId: "",
        currentRowIndex: "",
        workCenterList: [],
        dateRange: [],
        planStartDateRange: [],
        planFinishDateRange: [],
        deliveryDateRange: [],
        inspectionDateRange: [],
        instockDateRange: [],
        materialTypeList: [],
        materialTypeOptions: [],
        productInfo: {
          feedingStatus: 10,
        },
        searchShow: false,
        finishDateRange: "",
        options: [
          {name: "已开工", value: 30},
          {name: "已完工", value: 80},
          {name: "已检验", value: 90},
        ],
        biddingStage: [],
        filter: {
          productionOrderNo: "",
          billNo: "",
          materialNo: "",
          materialTypeId: "",
          materialTypeIds:"",
          materialName: "",
          materialSpecification: "",
          workCenterName: "",
          status: "",
          statuses: "",
          customerName: "",
          finalCustomerName: "",
          startFrom: "",
          startTo: "",
          planStartFrom: "",
          planStartTo: "",
          planFinishFrom: "",
          planFinishTo: "",
          finishFrom: "",
          finishTo: "",
          inspectionStartTime: "",
          inspectionEndTime: "",
          instockStartTime: "",
          instockEndTime: "",
          soDeliveryStartDate: "",
          soDeliveryEndDate: "",
          salesOrderNo: "",
          customerContractNo: "",
          // isScheduled: "", // 只查询已开工、已排产的数据
          feedingStatus: "",
        },
        columnsProperty: [
          // {
          //   width: 55,
          //   align: "center",
          //   type: "expand",
          //   render: (h, params) => {
          //     return h("Table", {
          //       props: {
          //         data: params.row.routeProcessList,
          //         columns: [
          //           {
          //             title: "工序序号",
          //             key: "processIndex",
          //             width: 100,
          //           },
          //           {
          //             title: "工序名称",
          //             key: "processName",
          //             width: 200,
          //           },
          //           {
          //             title: "开工数量",
          //             key: "startNum",
          //             width: 100,
          //             align: "center",
          //           },
          //           {
          //             title: "完工数量",
          //             key: "finishNum",
          //             width: 100,
          //             align: "center",
          //           },
          //         ],
          //         border: true,
          //         stripe: true,
          //       },
          //     });
          //   },
          // },
          {
            key: "billNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.detailPage.open(params.row);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "displayProcess",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "p",
                {
                  style: {
                    whiteSpace: "pre",
                    textAlign:"left",
                  },
                },
                params.row.displayProcess ? params.row.displayProcess.replace(/<br>/g, "\n") : "",
              );
            },
          },
          {
            title: "采购到料状态",
            key: "purchaseStatus",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: params.row.purchaseStatus === "缺料" ? "red" : "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      if (params.row.purchaseStatus) {
                        this.$refs.stockPreview.open(params.row.productionOrderNo, true);
                      }
                    },
                  },
                },
                params.row.purchaseStatus,
              );
            },
          },
        ],
        tableFooterMsg: "",
      };
    },

    watch: {
      // 监听工单状态：如果有值就查询对应状态的数据 如果每值只查询已开工、已排产的数据
      "filter.status": {
        handler(val) {
          if (val) {
            this.filter.isScheduled = "";
          }
        },
      },
      "filter.statuses": {
        handler(val) {
          if (val) {
            this.biddingStage = [];
            this.options.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.biddingStage.push(item.value);
                }
              });
            });
          }
        },
      },
      "filter.planStartFrom": {
        handler(newVal) {
          if (newVal) {
            this.planStartDateRange = [];
            this.planStartDateRange.push(this.filter.planStartFrom);
            this.planStartDateRange.push(this.filter.planStartTo);
          }
        },
      },
      "filter.planFinishFrom": {
        handler(newVal) {
          if (newVal) {
            this.planFinishDateRange = [];
            this.planFinishDateRange.push(this.filter.planFinishFrom);
            this.planFinishDateRange.push(this.filter.planFinishTo);
          }
        },
      },
      "filter.startFrom": {
        handler(newVal) {
          if (newVal) {
            this.dateRange = [];
            this.dateRange.push(this.filter.startFrom);
            this.dateRange.push(this.filter.startTo);
          }
        },
      },
      "filter.finishFrom": {
        handler(newVal) {
          if (newVal) {
            this.finishDateRange = [];
            this.finishDateRange.push(this.filter.finishFrom);
            this.finishDateRange.push(this.filter.finishTo);
          }
        },
      },
      "filter.inspectionStartTime": {
        handler(newVal) {
          if (newVal) {
            this.inspectionDateRange = [];
            this.inspectionDateRange.push(this.filter.inspectionStartTime);
            this.inspectionDateRange.push(this.filter.inspectionEndTime);
          }
        },
      },
      "filter.instockStartTime": {
        handler(newVal) {
          if (newVal) {
            this.instockDateRange = [];
            this.instockDateRange.push(this.filter.instockStartTime);
            this.instockDateRange.push(this.filter.instockEndTime);
          }
        },
      },
      "filter.soDeliveryStartDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.soDeliveryStartDate);
            this.deliveryDateRange.push(this.filter.soDeliveryEndDate);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },

    mounted() {
      this.getMaterialTypeList();
      this.loadData(1);
    },
    methods: {
      // 查询
      // getList(pageNum) {
      //   this.$refs.vmTable.getList(pageNum);
      // },


      handleSelect(value) {
        if (value.length) {
          this.biddingStage = value;
          this.filter.statuses = value.join(",");
        } else {
          this.biddingStage = [];
          this.filter.statuses = "";
        }
      },

      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelectMaterialType(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      getTableFooterMsg() {
        this.tableFooterMsg = "总数量:0";
        this.$http.get("basic", "taskDispatchBillDisplays/selectCount", this.filter).then((res) => {
          if (res.success) {
            this.tableFooterMsg = "总数量:" + res.data;
          }
        });
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
        this.getTableFooterMsg();
      },
      // 选择工作中心
      workCenterSelect(row) {
        this.filter.workCenterName = row.workCenterName;
        this.loadData(1);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      handleClick() {
        this.dateRange = [];
        this.finishDateRange = [];
        this.deliveryDateRange = [];
        this.submitDateRange = [];
      },

      rowClick(row) {
        const tableData = this.$refs.vmTable.tableData;
        tableData.forEach((item, index) => {
          if (item.pkid === row.pkid) {
            this.currentRowIndex = index;
            this.productInfo = row;
            this.productionOrderId = row.pkid;
          }
        });
      },

      selectedRow(row, index) {
        this.currentRowIndex = index;
        this.productInfo = row;
        this.productionOrderId = row.pkid;
      },

      setSelectedRow(val) {
        this.rowClick(val);
      },
    },
  };
</script>

<style>
.productTask .el-table__body-wrapper::-webkit-scrollbar {
  width: 16px !important;
  height: 16px !important;
  z-index: 99999;
}

.productTask .el-table__fixed-right-patch {
  width: 16px !important;
}

.productTask .el-table__fixed-right {
  right: 16px !important;
  bottom: 16px !important;
}

.productTask .el-table .el-table__cell {
  padding: 8px 0;
}

.biddingStageSty /deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
</style>
